import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { buildProviders, KalDate } from '@kalidea/kaligraphi';
import { monthsList } from 'src/environments/date/date';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { FormValidator } from 'src/app/validators/form-validator';
import { CustomFormElement } from 'src/app/_core/tools/custom-form-element';

const YEAR_RANGE = 12;
const YEAR_OFFSET = -2;

export type MonthAndYear = {month: number, year: number};

@Component({
    selector: 'app-shared-month-and-year-picker',
    templateUrl: './shared-month-and-year-picker.component.html',
    styleUrls: ['./shared-month-and-year-picker.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(SharedMonthAndYearPickerComponent),
    standalone: false
})
export class SharedMonthAndYearPickerComponent<T extends MonthAndYear> extends CustomFormElement<T> implements OnInit {

    readonly monthsList = monthsList;

    yearsList: number[] = [];

    form: UntypedFormGroup;

    @Input() monthPlaceholder = 'Sélectionnez un mois';
    @Input() monthLabel = '';

    @Input() yearPlaceholder = 'Sélectionnez une année';
    @Input() yearLabel = '';

    constructor(private readonly fb: UntypedFormBuilder,
                private readonly injector: Injector) {
        super();
    }

    writeValue(value: T): void {
        this.form.patchValue({
            month: value?.month || null,
            year: value?.year || null
        }, {emitEvent: false});

        super.writeValue(value);
    }

    validate(c: AbstractControl): Observable<ValidationErrors> {
        return of(this.form.valid ? null : {monthandyearpicker: true});
    }

    ngOnInit(): void {
        this.createControlAndSubscriptions(this.injector);

        this.form = this.fb.group({
            month: [null, [FormValidator.int]],
            year: [null, [FormValidator.int]]
        }, {
            validators: [
                form => (!form.value.month !== !form.value.year) ? {invalidvalue: true} : null
            ]
        });

        const currentYear = new KalDate().getYear();
        for (let year = currentYear + YEAR_OFFSET; year < currentYear + YEAR_OFFSET + YEAR_RANGE; year++) {
            this.yearsList.push(year);
        }

        this.watch$ = this.form.valueChanges.pipe(
            distinctUntilChanged(),
            tap(value => this.notifyUpdate(value))
        );
    }

}
